import type { AsyncBelongsTo } from '@ember-data/model';
import type { ValidatorMap } from 'ember-changeset/types';
import { validatePresence } from 'ember-changeset-validations/validators';
import type { GroupInviteValidationsOptions } from 'garaje/changesets/new-group-invite';
import type Employee from 'garaje/models/employee';
import type GroupInvite from 'garaje/models/group-invite';
import type RecurringGroupInvite from 'garaje/models/recurring-group-invite';
import RecurringRule from 'garaje/models/recurring-rule';
import { resolve } from 'rsvp';

export default function buildGroupInviteValidations(options: GroupInviteValidationsOptions = {}): ValidatorMap {
  const defaults = {
    hostFieldIsRequired: false,
    checkEmailRequired: false,
    store: null,
  };

  options = Object.assign({}, defaults, options);

  const timeField = options.recurring ? 'startTime' : 'expectedArrivalTime';

  const validations: ValidatorMap = {
    flow(_key: string, _newValue: unknown, _oldValue: unknown, changes: GroupInvite, content: GroupInvite) {
      if (!content.flow && !changes?.flow) {
        return 'This is a required field';
      }

      return true;
    },
    employee(_key: string, newValue: AsyncBelongsTo<Employee>) {
      return resolve(newValue).then((employee) => {
        if (options.hostFieldIsRequired && !employee) {
          return 'Employee is required';
        }

        return true;
      });
    },
    [timeField]: [
      validatePresence({
        presence: true,
        message: 'This is a required field',
      }),
    ],
    groupName: [
      validatePresence({
        presence: true,
        message: 'This is a required field',
      }),
    ],
  };

  if (options.recurring) {
    validations['recurringRule'] = (
      _key: string,
      _newValue: unknown,
      _oldValue: unknown,
      changes: RecurringGroupInvite,
    ) => {
      const { recurringRule } = changes;
      if (!recurringRule) return 'This is a required field';

      const parsedRule = RecurringRule.parse(recurringRule);
      const { frequency, until } = parsedRule;
      if (Boolean(frequency) && !until) return 'This is a required field';

      return true;
    };
  }

  return validations;
}
